namespace AgerLMS {
    export interface VideoPlayerSettings {
        VisibilityChange?: boolean;
        WatermarkImage?: string;
        Speed?: number;
        TcText?: string;
        BackgroundColor?: string;
        FontColor?: string;
        Opacity?: number;
    }
}
